import { render, staticRenderFns } from "./category-money.vue?vue&type=template&id=b93c0788&scoped=true"
import script from "./category-money.vue?vue&type=script&lang=js"
export * from "./category-money.vue?vue&type=script&lang=js"
import style0 from "./category-money.vue?vue&type=style&index=0&id=b93c0788&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b93c0788",
  null
  
)

export default component.exports